var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.81 37.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#191919;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-7{fill:#870b7a;}.cls-2{fill:#fff;}.cls-3{opacity:.25;}.cls-8{stroke-width:1.1px;}.cls-8,.cls-9,.cls-10,.cls-11{fill:none;}.cls-8,.cls-11{opacity:.5;stroke:#80b2c8;stroke-linecap:round;}.cls-9{stroke-width:1.5px;}.cls-9,.cls-10{stroke:#870b7a;}.cls-12,.cls-5{fill:#333;}.cls-13{fill:#272727;}.cls-14,.cls-6{fill:#212121;}.cls-10{stroke-width:3px;}.cls-4{fill:#2b2b2b;}.cls-11{stroke-width:.74px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: ".53 21.05 9.21 12.38 13.49 16.66 25.58 4.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m22.51,3.47l5.3-1.43c.22-.06.42.14.36.36l-1.43,5.3c-.06.22-.33.29-.49.13l-3.87-3.87c-.16-.16-.09-.43.13-.49Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 25.43,
    y: 14.51,
    width: 0.96,
    height: 16.97,
    transform: "translate(-8.67 25.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 22.87,
    y: 15.96,
    width: 3.16,
    height: 16.97,
    transform: "translate(-10.13 24.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m25.93,20.43l11.55,11.55c.44.44.43,1.14,0,1.57l-3.25,3.25c-.44.44-1.13.44-1.57,0l-11.55-11.55c-.43-.43-.44-1.13,0-1.57l3.25-3.25c.43-.43,1.14-.43,1.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.98,21.37l11.55,11.55c.44.44.43,1.14,0,1.58l-2.3,2.3c-.44.44-1.13.44-1.57,0l-11.55-11.55c-.43-.43-.44-1.13,0-1.57l2.3-2.3c.44-.44,1.15-.44,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.93,19.69c-.24.28-.48.55-.74.81-.49.49-1.03.94-1.58,1.33l.42.42c.56-.39,1.09-.83,1.58-1.33.26-.26.5-.53.74-.81.21-.25.4-.5.59-.77l-.42-.42c-.18.27-.38.52-.59.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 20.62,
    y: 21.91,
    width: 4.12,
    height: 0.16,
    transform: "translate(-8.91 22.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m21.19,20.51c-4.68,4.7-12.3,4.7-17,0-4.68-4.68-4.68-12.3,0-17,4.7-4.68,12.31-4.68,17,0s4.7,12.31,0,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.39,18.71c-3.69,3.71-9.7,3.71-13.4.01-3.7-3.7-3.69-9.7,0-13.41,3.7-3.69,9.7-3.69,13.4.01,3.7,3.7,3.7,9.7,0,13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.39,18.71c-3.69,3.7-9.7,3.7-13.4,0-3.69-3.69-3.69-9.7,0-13.4,3.7-3.69,9.71-3.69,13.4,0s3.7,9.71,0,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.39,18.71c-3.69,3.7-9.7,3.7-13.4,0-3.69-3.69-3.69-9.7,0-13.4,3.7-3.69,9.71-3.69,13.4,0s3.7,9.71,0,13.4Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "3.85 17.73 9.2 12.38 13.49 16.67 22.42 7.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 5.05,
    y1: 9.72,
    x2: 10.17,
    y2: 4.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 5.12,
    y1: 12.02,
    x2: 12.7,
    y2: 4.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.78,3.92C16.32-.54,9.07-.54,4.6,3.92.14,8.4.14,15.65,4.6,20.11c4.47,4.47,11.72,4.47,16.18,0,4.47-4.46,4.47-11.71,0-16.19Zm-1.39,14.79c-3.69,3.71-9.7,3.71-13.4.01-3.7-3.7-3.69-9.7,0-13.41,3.7-3.69,9.7-3.69,13.4.01,3.7,3.7,3.7,9.7,0,13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m19.39,5.32c-3.7-3.7-9.7-3.7-13.4-.01-3.69,3.71-3.7,9.71,0,13.41,3.7,3.7,9.71,3.7,13.4-.01,3.7-3.69,3.7-9.69,0-13.39Zm-.44,12.96c-3.45,3.46-9.06,3.46-12.52,0-3.45-3.45-3.45-9.06,0-12.53,3.46-3.45,9.07-3.44,12.52.01,3.46,3.46,3.46,9.07,0,12.52Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoIcon);
export default __webpack_public_path__ + "static/media/seoIcon.7f296cdc78a84c8532872e7421c14c84.svg";
export { ForwardRef as ReactComponent };